export default __webpack_public_path__ + "static/media/logical-xor.b73aac91.svg";